import { inject, Injectable, NgZone } from '@angular/core';
import { asyncScheduler, fromEvent, merge, Subscription, Subject, interval, throttleTime } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class InactivityCheckerService {
	private readonly ngZone = inject(NgZone);

	// RXJS Subject that controls the time when the timer reaches its full duration
	public _userActionOccured = new Subject<void>();
	_userActionOccured$ = this._userActionOccured.asObservable();

	// timerSubscription
	public timerSubscription!: Subscription;

  constructor() { }

	public listenForUserActivity(onActivity: () => void): Subscription {
		return this.ngZone.runOutsideAngular(() => {
			const events = ['keyup', 'click', 'wheel', 'mousemove'];
			return merge(...events.map(event => fromEvent(document, event, { passive: true })))
				.pipe(throttleTime(1000, asyncScheduler, { leading: true, trailing: true }))
				.subscribe(onActivity);
		});
	}

	public startTimer() {
		this.resetTimer();
	}

	public notifyUserAction() {
		this.resetTimer();
	}

	public notifyRefreshAction() {
		this._userActionOccured.next();
	}

	// resets timer to restart the idle countdown back to 30 minutes
	public resetTimer() {
		if (this.timerSubscription) {
			this.timerSubscription.unsubscribe();
		}

		const duration = 1500000; // 25 min = 1500000 ms
		this.timerSubscription = interval(duration).subscribe({
			next: () => this.notifyRefreshAction()
		});
	}
}
